/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext, useEffect, useState } from "react";
import dayjs from "dayjs";
import { Button } from "@mui/material";
import { ImageEditContext } from "cms/images/image-selector/context/image-edit-context";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import { formatBytes } from "utils/format-bytes";
import Config from "data/config";
import { ImageCover } from "cms/images/image-cover/image-cover";

function formatDate (date) {
    return dayjs(date).format(Config.dates.display.datetime);
}

const ImageDialogPreviewPanel = () => {

    const imageEditContext = useContext(ImageEditContext);
    const setSelectedEditTab = imageEditContext?.setSelectedEditTab;
    const onEdit = imageEditContext?.onEdit;
    const selectedImage = imageEditContext?.selectedImage;

    const [imageUrl, setImageUrl] = useState("");

    useEffect(() => {
        if (selectedImage) {
            setImageUrl(selectedImage.url);
            // setImageWidth(selectedImage.width);
        }
    }, [selectedImage]);

    const handleEdit = () => {
        setSelectedEditTab(0);
        onEdit();
    };
    
    const handlePlacements = () => {
        setSelectedEditTab(1);
        onEdit();
    };
    
    return (
        <Fragment>
            {!imageUrl ? (
                <div className="simplicity-image-selector-window-preview-none">
                    No image selected
                </div>
            ) : (
                <div className="simplicity-image-selector-window-preview">
                    <div className="simplicity-image-selector-edit">
                        <div className="header">
                            Details
                        </div>
                        <div style={{
                            width: "100%",
                            height: "100%",
                            padding: "24px",
                            borderTop: "0",
                            borderRight: "1px solid #DFDFDF",
                            borderBottom: "1px solid #DFDFDF",
                            borderLeft: "1px solid #DFDFDF",
                        }}
                        >

                            <div style={{
                                display: "flex", flexDirection: "row",
                                width: "100%", gap: "12px", padding: "8px",
                                justifyContent: "space-between",
                                // border: '1px solid red',
                            }}
                            >
                                <ImageCover
                                    displayWidth={150}
                                    displayHeight={100}
                                />
                                <div style={{
                                    // flexGrow: 1,
                                    display: "flex",
                                    // margin: '20px',
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                                >
                                    <Button
                                        variant='outlined'
                                        color='secondary'
                                        size='small'
                                        onClick={handleEdit}
                                        startIcon={<ModeEditOutlineOutlinedIcon color='secondary' />}
                                    >
                                        Edit
                                    </Button>
                                </div>
                            </div>

                            <div className="summary-details">
                                <div className='detail-property'>
                                    <span className='detail-property-key'>Modified: </span>
                                    {selectedImage && formatDate(selectedImage.updated_at)}
                                </div>
                                {/*<div className='detail'><span>Uploaded:</b> {selectedImage && formatDate(selectedImage.created_at)}</div>*/}
                                <div className='detail-property'>
                                    <span className='detail-property-key'>Size: </span>
                                    {selectedImage && formatBytes(selectedImage.file_size)}
                                </div>
                                <div className='detail-property'>
                                    <span className='detail-property-key'>Filename: </span>
                                    {selectedImage && selectedImage.file_name}
                                </div>
                                <div className='details-flex'>
                                    <div className='detail-property'>
                                        <span className='detail-property-key'>Dimensions: </span>
                                        {selectedImage && selectedImage.width}x{selectedImage && selectedImage.height}pixels</div>
                                    <div className='detail-link'><a href={selectedImage.url} target='_new'>View original</a></div>
                                </div>
                                <div className='detail-space'></div>
                                <div className='detail-title'>Title:</div>
                                <div className='detail' style={{ fontWeight: "700" }}>{selectedImage.title}</div>
                                <div className='detail-space'></div>
                                <div className='detail-title'>Alt Text:</div>
                                <div className='detail'>{selectedImage.alt}</div>
                                <div className='detail-space'></div>
                                <div className='detail-title'>Caption:</div>
                                <div className='detail'>{selectedImage.description}</div>
                                <div className='detail-space'></div>

                                <div className='details-flex'>
                                    <div className='detail-title'>Placements:</div>
                                    <div className='detail-link'>
                                        <a
                                            href='#'
                                            onClick={handlePlacements}
                                        >
                                            Details
                                        </a>
                                    </div>
                                </div>
                                {/* FIXME: implement Placements */}
                                <div className='detail'>Placements is not implemented{/* This image is used everywhere */}</div>
                                <div className='detail-space'></div>
                                {/*<div className='detail-title'>Keywords:</div>*/}
                                {/*<div className='detail-keywords'></div>*/}
                            </div>

                            {/*<div className="header">*/}
                            {/*    Properties*/}
                            {/*</div>*/}

                        </div>

                    </div>
                </div>
            )}
        </Fragment>
    );
};

export { ImageDialogPreviewPanel };
